import { PasswordField } from '@razz-team/ui-web';
import { OtpField } from '../../Field/OtpField';
import { useTranslation } from 'react-i18next';
import { ApiAuthChallengeRequired } from '../../../openapi';
import { useCallback, useEffect, useState } from 'react';
import { useAuthMutation, useOtpResendMutation } from '../../../api/auth';
import { addSeconds } from 'date-fns';

export function AuthChallenge({
  challenge,
  authMutation,
}: {
  challenge: ApiAuthChallengeRequired;
  authMutation: ReturnType<typeof useAuthMutation>;
}) {
  const { t } = useTranslation();

  const otpResendMutation = useOtpResendMutation();
  const questId = authMutation.data?.questId ?? authMutation.variables?.questId;
  const [resendAllowedAt, setResendAllowedAt] = useState<Date | undefined>(undefined);

  useEffect(() => {
    if (authMutation.data?.type === 'CHALLENGE_REQUIRED' && authMutation.data.otp) {
      setResendAllowedAt(addSeconds(new Date(), authMutation.data.otp.resendInSec));
    }
  }, [authMutation.data, authMutation.submittedAt]);
  useEffect(() => {
    if (otpResendMutation.data) {
      setResendAllowedAt(addSeconds(new Date(), otpResendMutation.data.resendInSec));
    }
  }, [otpResendMutation.data, otpResendMutation.submittedAt]);

  const handleOtpResend = useCallback(() => {
    if (questId) {
      otpResendMutation.mutate({
        questId,
      });
    }
  }, [otpResendMutation, questId]);

  switch (challenge?.challenge) {
    case 'PASSWORD':
      return (
        <PasswordField
          key="password"
          name="password"
          label={t('Password')}
          fullWidth
          type="password"
          required
          autoComplete="current-password"
          autoFocus
        />
      );
    case 'SET_NEW_PASSWORD':
      return (
        <PasswordField
          key="newPassword"
          name="newPassword"
          label={t('New password')}
          fullWidth
          type="password"
          required
          autoComplete="new-password"
          autoFocus
        />
      );
    default:
      if (challenge?.otp) {
        return (
          <OtpField
            name="otp"
            label={t('OTP code')}
            fullWidth
            required
            autoFocus
            resendAllowedAt={resendAllowedAt}
            onResend={handleOtpResend}
          />
        );
      }

      return null;
  }
}
